import React, { useCallback, useEffect, useState } from "react";
import { Row, Col, Input, Label, Form, FormFeedback, Modal, ModalHeader, ModalFooter, ModalBody, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import InputCustom from "../../components/Common/InputCustom";
import { getPropertyReceipt as onGetPropertyReceipt } from "store/Property/actions";
import * as Yup from "yup";
import { useFormik } from "formik";
const ModalFormGetReceiptProperty = props => {

    const { toggleReceiptPropertyModal, receiptPropertyModalShow  } = props;

    const dispatch = useDispatch();
    let propertyL = {...props.property}

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            name_guardian: (propertyL && propertyL.name_guardian) || "",
            position_guardian: (propertyL && propertyL.position_guardian) || "",

        },
        validationSchema: Yup.object({
            name_guardian: Yup.string().required("El nombre del custodio es requerido"),
            position_guardian: Yup.string().required("El puesto del custodio es requerido"),
        }),
        onSubmit: (values) => {
            const updateProperty = {
                uuid: propertyL ? propertyL?.uuid : null,
                name_guardian: values["name_guardian"],
                position_guardian: values["position_guardian"],
            };
            dispatch(onGetPropertyReceipt(updateProperty));

        }
    });


    return (
        <React.Fragment>
            <Modal size={"lg"} isOpen={receiptPropertyModalShow} backdrop={'static'} toggle={toggleReceiptPropertyModal}>
                <ModalHeader toggle={toggleReceiptPropertyModal} tag="h4">
                    {"Obtener resguardo del bien " + props?.property?.concept}
                </ModalHeader>
                <Form
                    onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                    }}
                >
                    <ModalBody>
                        <Row>
                            <Col className="col-12">
                                <InputCustom
                                    lblInput="Nombre del resguardante"
                                    inputName="name_guardian"
                                    inputType="text" readonly
                                    inputPlaceholder="Nombre del resguardante"
                                    validation={validation}
                                />
                                <InputCustom
                                    lblInput="Puesto del resguardante"
                                    inputName="position_guardian"
                                    inputType="text"
                                    inputPlaceholder="Ingrese el puesto del resguardante"
                                    validation={validation}
                                />                  
                            </Col>   
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={toggleReceiptPropertyModal}>Cancelar </Button>
                        <button type="submit" className="btn btn-success">
                            Obtener resguardo
                        </button>
                    </ModalFooter>
                </Form>
            </Modal>
        </React.Fragment>
    )
}

export default ModalFormGetReceiptProperty
